var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10.313 8.692l6.312-6.313A1.282 1.282 0 1014.813.566L8.5 6.88 2.187.566A1.282 1.282 0 10.375 2.38l6.312 6.313-6.312 6.312a1.282 1.282 0 101.812 1.813L8.5 10.504l6.313 6.313a1.281 1.281 0 101.813-1.813l-6.313-6.312","fill":"#BCBCBC"}));
}

Close.defaultProps = {"width":"17","height":"17","viewBox":"0 0 17 17","fill":"none"};

module.exports = Close;

Close.default = Close;
